<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:00em; padding-top:15px;">Peter King has always been interested in writing, and decided to take his interest further by writing a book during the COVID-19 lockdowns from his job as a Teaching Assistant at a primary school. Prior to working at a school, he trained as a design draughtsman, working on domestic and industrial controls.</p>
<p style="text-indent:00em; padding-top:15px;">Another passion of his is sport—Peter is a keen badminton player and golfer. He also enjoys angling and following football and cricket. Peter spends as much time with his grandchildren, who share the same interests. Being a father and a grandfather, this has given him plenty of experiences that he has been able to build into his book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?b7a0414e